import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaUser } from "react-icons/fa";
import Login from "../pages/auth/Login";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const UserIcon = ({ isMobile = false }) => {
  const { t } = useTranslation();
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const token = localStorage.getItem("access");
  const navigate = useNavigate();
  const lang = useLanguage();

  const handleClick = () => {
    if (token) {
      navigate(`/${lang}/profile`);
    } else {
      setIsLoginOpen(true);
    }
  };

  const handleClose = (reason?: string) => {
    setIsLoginOpen(false);
    if (isMobile && reason === "manual") {
      navigate(`/${lang}/profile`);
    }
  };

  if (isMobile) {
    return (
      <div className="flex flex-col items-center justify-center">
        <div
          onClick={handleClick}
          className="flex flex-col justify-center items-center cursor-pointer"
          role="button"
          aria-label={t('user')}
        >
          <FaUser size={24} />
          <p className="text-xs">{t('user')}</p>
        </div>
        <Login isOpen={isLoginOpen} onClose={handleClose} />
      </div>
    );
  }

  return (
    <div>
      <div
        onClick={handleClick}
        className="flex items-center gap-2 bg-brand-gradient text-white rounded-[10px] px-3 py-1 cursor-pointer hover:bg-brand-gradient transition"
      >
        <FaUser />
        <span className="text-sm">{token ? t("account") : t("login")}</span>
      </div>
      <Login isOpen={isLoginOpen} onClose={handleClose} />
    </div>
  );
};

export default UserIcon;
